/**
 * Enum para quantidade de temas visíveis na lista de temas não publicados,
 * mesma quantidade de temas retornados na api
 * @enum {number}
 */
export enum UnpublishedListThemes {
  VISIBLE_LIMIT = 16,
}
